import { flexRender } from "@tanstack/react-table";

import { cx } from "@/utils";
import SortIcon from "./sort-icon";

export default function TableHeaderCell({ header }) {
  const canSort = header.column.getCanSort();
  const onClick = canSort ? header.column.getToggleSortingHandler() : null;

  return (
    <th
      className={cx(
        "border-cp-grey-300 whitespace-nowrap border-b px-4 py-2 text-left text-xs font-semibold tracking-wider",
        canSort && "cursor-pointer",
      )}
      onClick={onClick}
    >
      <div className="text-cp-grey-800 flex items-center gap-1">
        {flexRender(header.column.columnDef.header, header.getContext())}

        <div className="size-4">
          <SortIcon header={header} />
        </div>
      </div>
    </th>
  );
}
